import {
  ReservationFlowPaymentMethodListSubscription,
  ReservationFlowCustomerSubscriptionAvailableReservationCount,
} from '../../../../interfaces/reservation_flow';

import { isRestrictedCustomerSubscriptionReservationCount } from '../is-restricted-customer-subscription-reservation-count';

export const isAvailableSubscriptionProduct: (params: {
  product: ReservationFlowPaymentMethodListSubscription['products'][number];
  availableReservationCounts: ReservationFlowCustomerSubscriptionAvailableReservationCount[];
}) => boolean = ({ product, availableReservationCounts }) => {
  if (product.active_customer_subscriptions.length === 0) {
    return false;
  }

  const activeCustomerSubscription = product.active_customer_subscriptions[0];

  const count = availableReservationCounts.find((availableReservationCount) => {
    return (
      availableReservationCount.publicId ===
      activeCustomerSubscription.public_id
    );
  });

  if (typeof count === 'undefined') {
    return false;
  }

  return !isRestrictedCustomerSubscriptionReservationCount(count);
};
